import Page from "../Common/Page";
import React from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Divider,
  Space,
  Layout,
  message,
} from "antd";
import { LockOutlined } from "@ant-design/icons";
import { Messages } from "../Common/ValidateMessages";
import { http } from "../Common/http";
import { AuthContext } from "../Auth/Auth";
import { Content } from "antd/lib/layout/layout";
import "../Style/Password.css";

type FormData = {
  password: string;
  old_password: string;
};

class ChgPasswordPage extends React.Component<any> {
  // state = {
  //   loginError: "none",
  //   loginErrorMsg: "",
  //   Infomation: "none",
  //   loginTypeMsg: "エラー",
  // };

  private _page: React.RefObject<Page>;
  static contextType = AuthContext;
  constructor(props: any) {
    super(props);
    this._page = React.createRef<Page>();
  }

  submitForm = async (data: FormData) => {
    // this.setState({ loginError: "none" });
    // this.setState({ Infomation: "none" });
    // this.setState({ loginErrorMsg: "" });
    this._page.current?.setState({ isPageLoading: true });

    try {
      const result = await http<
        undefined,
        {
          Password: string;
          OldPassword: string;
        }
      >({
        path: "/ChgPassword",
        method: "post",
        body: {
          OldPassword: data.old_password,
          Password: data.password,
        },
        accessToken: this.context.accessToken,
        noResponsebody: true,
      });
      if (result.ok) {
        // this.setState({ loginError: "none" });
        // this.setState({ Infomation: "none" });
        this._page.current?.setState({ isPageLoading: false });
        window.location.replace("/CompleteChangePassword");
      } else {
        /* APIエラー 判定 */
        // パスワードの変更に失敗しました
        // this.setState({ loginErrorMsg: Messages["ERR-039"] });
        // this.setState({ loginError: "" });
        if (result.statusCode === 400) {
          message.error(Messages["ERR-038"]);
        } else {
          message.error(Messages["ERR-039"]);
        }
        this._page.current?.setState({ isPageLoading: false });
      }
    } catch (error) {
      // this.setState({ loginError: "" });
      // this.setState({ loginTypeMsg: "エラー" });
      console.log(error);
      message.error(Messages["ERR-039"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  onFormValueChange = () => {
    // this.setState({ loginError: "none" });
    // this.setState({ Infomation: "none" });
  };

  // validator
  validatorIsPassword = async (_: any, value: string): Promise<void> => {
    const pattern = {
      password: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[!-~]{8,30}$/,
    };
    if (
      value !== undefined &&
      value != null &&
      value.length <= 30 &&
      !value.match(pattern.password)
    ) {
      // TODO メッセージ
      return Promise.reject(new Error(Messages["ERR-038"]));
    }
    return Promise.resolve();
  };

  render() {
    return (
      <>
        <Page title="パスワード変更" ref={this._page} noCheckAuthority={true}>
          <Layout style={{ padding: "0 24px 24px" }}>
            <Content
              className="site-layout-background"
              style={{
                padding: 24,
                margin: 0,
                minHeight: 280,
              }}
            >
              {/* <Row style={{ display: this.state.loginError }}>
                <Col span={6}>
                  <Alert
                    type="error"
                    description={this.state.loginErrorMsg}
                    message={this.state.loginTypeMsg}
                  />
                </Col>
              </Row>
              <Row style={{ display: this.state.Infomation }}>
                <Col span={6}>
                  <Alert
                    type="info"
                    description={this.state.loginErrorMsg}
                    message={this.state.loginTypeMsg}
                  />
                </Col>
              </Row> */}
              <Row>
                <Col span={10}>
                  <Form
                    name="password"
                    layout="vertical"
                    onFinish={this.submitForm}
                    onValuesChange={this.onFormValueChange}
                    autoComplete="off"
                    className="login-form"
                    validateTrigger={["onBlur"]}
                  >
                    <Form.Item
                      name="old_password"
                      label="旧パスワード"
                      rules={[{ required: true }, { max: 30 }, { min: 8 }]}
                    >
                      <Input.Password
                        prefix={
                          <LockOutlined className="site-form-item-icon" />
                        }
                        placeholder="パスワード"
                        maxLength={30}
                      />
                    </Form.Item>

                    <Form.Item
                      name="password"
                      label="パスワード"
                      rules={[
                        { required: true },
                        { max: 30 },
                        { min: 8 },
                        { validator: this.validatorIsPassword },
                      ]}
                    >
                      <Input.Password
                        prefix={
                          <LockOutlined className="site-form-item-icon" />
                        }
                        placeholder="パスワード"
                        maxLength={30}
                      />
                    </Form.Item>
                    <Form.Item
                      name="confirm"
                      label="パスワード確認"
                      dependencies={["password"]}
                      rules={[
                        { required: true },
                        // { max: 30 },
                        // { min: 8 },
                        // { validator: this.validatorIsPassword },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue("password") === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error(Messages["ERR-014"])
                            );
                          },
                        }),
                      ]}
                    >
                      <Input.Password
                        prefix={
                          <LockOutlined className="site-form-item-icon" />
                        }
                        placeholder="パスワード"
                        maxLength={30}
                      />
                    </Form.Item>
                    <br />
                    <Form.Item>
                      <Space split={<Divider type="vertical" />} size={"large"}>
                        <Button
                          type="primary"
                          htmlType="submit"
                          className="login-form-button"
                        >
                          パスワード変更
                        </Button>
                      </Space>
                    </Form.Item>
                  </Form>
                </Col>
                <Col span={8}>
                  <Row>
                    <Col>
                      <div
                        id={"PolicyClolor"}
                        style={{ padding: "0 24px 24px" }}
                      >
                        <h3 id={"PolicyClolor"}>パスワードポリシー</h3>
                        <ul style={{ padding: "0 24px 24px" }}>
                          <li>英字：最低大文字1文字以上を含む</li>
                          <li>英字：最低小文字1文字以上を含む</li>
                          <li>数字：最低1文字を含む</li>
                          <li>長さ：最低8文字以上30文字まで</li>
                          <li>文字種：半角文字</li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Content>
          </Layout>
        </Page>
      </>
    );
  }
}
export default ChgPasswordPage;
